import Pusher from 'pusher-js';
import { API_URL_WITH_V3, PUSHER } from '../config';

// Enable pusher logging - don't include this in production
// Pusher.logToConsole = true;

export const pusher = new Pusher(PUSHER.KEY, {
  cluster: 'mt1',
  forceTLS: true,
  authEndpoint: `${API_URL_WITH_V3}/users/pusher/auth`,
  auth: {
    headers: {
      Authorization: `JWT ${localStorage.getItem('token')}`,
    },
  },
});
